/*
 * frost-expansions.js (owner: CONTENT) – <fb-expansions>
 * The „Benachrichtige mich“ links point to #flocken-post; scrolling + focusing the e-mail field
 * (and adding the interest tag) is done by frost-guest-list.js. This element only makes sure the
 * link still leads somewhere when the newsletter is not on the current page (→ home page anchor),
 * and scrolls the swipe row to the selected block in the theme editor.
 */
(function () {
  'use strict';

  if (!window.customElements || window.customElements.get('fb-expansions')) return;

  window.customElements.define(
    'fb-expansions',
    class extends HTMLElement {
      connectedCallback() {
        this._onBlockSelect = this.onBlockSelect.bind(this);
        this._onSectionLoad = this.retarget.bind(this);
        document.addEventListener('shopify:block:select', this._onBlockSelect);
        document.addEventListener('shopify:section:load', this._onSectionLoad);
        document.addEventListener('shopify:section:unload', this._onSectionLoad);
        this.retarget();
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this._onBlockSelect);
        document.removeEventListener('shopify:section:load', this._onSectionLoad);
        document.removeEventListener('shopify:section:unload', this._onSectionLoad);
      }

      retarget() {
        var anchor = this.getAttribute('data-anchor') || 'flocken-post';
        /* Same lookup as frost-product.js: the Flocken-Post section, else the footer newsletter
           (own id, or the heading it is labelled by). Only without any sign-up on this page do
           the links fall back to the home page. */
        var target =
          document.getElementById(anchor) ||
          document.querySelector('section.fb-guest[id]') ||
          document.querySelector('.fb-footer__news[id], .fb-footer__news[aria-labelledby]');
        if (target && this.contains(target)) target = null;
        var id = target ? target.id || target.getAttribute('aria-labelledby') || '' : '';
        if (id && !document.getElementById(id)) id = '';
        var home = this.getAttribute('data-home') || '/';
        if (home.charAt(home.length - 1) !== '/') home += '/';
        Array.prototype.forEach.call(this.querySelectorAll('[data-fb-notify]'), function (link) {
          link.setAttribute('href', id ? '#' + id : home + '#' + anchor);
        });
      }

      onBlockSelect(event) {
        if (!event.target || !this.contains(event.target)) return;
        var item = event.target.closest('.fb-exp__item');
        var row = this.querySelector('.fb-exp__rail');
        if (!item || !row || row.scrollWidth <= row.clientWidth) return;
        var pad = parseFloat(window.getComputedStyle(row).scrollPaddingLeft) || 16;
        row.scrollTo({
          left: row.scrollLeft + item.getBoundingClientRect().left - row.getBoundingClientRect().left - pad,
          behavior: 'auto',
        });
      }
    }
  );
})();
